import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-about-team",
  templateUrl: "./about-team.component.html",
  styleUrls: ["./about-team.component.css"]
})
export class AboutTeamComponent implements OnInit {
  team = [
  {
      name: "Bhavna Priyadarshini",
      designation: "CEO",
      describtion:
        "As the Chief Executive Officer of company, Bhavna has enjoyed a spectacular run in the IT industry. She uses all the experience that she has accumulated from running various IT businesses to understand the needs of our clients. Before joining ISAN Data Systems, Bhavna worked in various roles in the IT business and non-profit sector. She has done master’s in Art from Vinoba Bhave University. Bhavna has immense experience of working with IT industry and Education Sector. A young and creative mind with astonishing ideas and solutions to every problem, adding great values to the position. Bhavna being a responsible leader, helpful mentor for the team member and a supportive leader of the company is the most amazing quality about her. With her on the position means taking the company to the new heights of success and bringing glories for the company.",
      image: "7.png"
    },
  {
      name: "Eksha Arora",
      designation: "Director",
      describtion:
        "Eksha, an IT professional with more than 10 years of rich experience in the areas of implementation, transition, and migration of Infrastructure services. An Army School alumni who completed her higher studies from the University of Jammu in Electronics, and Communications engineering. She started her career as a Storage Administrator in IBM, worked there for around 3.5 years and then moved to HCL Technologies as a Technical Consultant in the Infrastructure Services Division. She moved to Australia in 2018 after getting her permanent residency and joined “NBN Australia” as  Infrastructure Specialist. With immense knowledge and experience of working in Public Cloud and Hybrid Cloud Model, she joined ISAN DATA SYSTEMS in 2020 as a director.",
      image: "6.png"
    },
    {
      name: "Sunil Kumar Singh",
      designation: "Director",
      describtion:
        "As the operational head of the company, Sunil has enjoyed a spectacular run in the IT industry. He uses all the experience that he has accumulated from running various IT businesses to understand the needs of our clients fully. Thus, Sunil helps us deliver solutions that are entirely in line with our customers’ requirements. He is undoubtedly the reason for the company’s strong customer-oriented branding.",
      image: "1.png"
    },
    {
      name: "Seema Sharma",
      designation: "Director",
      describtion:
        "Under the aegis of Seema, She leverages her extensive IT experience to guide our young group of experts and build strategies that deliver predictable and sustained growth. She excels in bringing the client's visions from concept to reality. Her unique combination of database experience, network & software support and map production translates remarkably well to our technical and visual aspects of IT infrastructure.",
      image: "5.png"
    },
    
    
    {
      name: "Kanti Chaudhary",
      designation: "Human Resource Head",
      describtion:
        "Starting her career from ISAN Data Systems, Kanti has consistently risen through the ranks. She is currently working in the company as the human resource and employee engagement leader. As a young Turk responsible for bringing in the most exceptional talent in the company, Kanti has been doing an excellent job at making this organization a much better place to work at.",
      image: "2.png"
    },
    {
      name: "Soni Kumari",
      designation: "Digital Marketing Strategist",
      describtion:
        "As the Digital marketing mind of ISAN DATA SYSTEMS, Soni believes in experimenting with the digital aspects of today’s world to bring out the firm’s best and always comes with actionable ideas to propel the brand name further. She holds an engineering degree in Computer science with a solid grasp of website development and Digital Marketing experience. She started her career as project engineer in Wipro, worked there for around 2 years and then moved to ISAN DATA SYSTEMS as a Digital Marketing Strategist leader. Her zeal for building things right from its first block drove her to work with ISAN and its team.She is glad to take charge of the marketing aspects of the company to build the brand name from the ground up and drive an era of growth and productivity for the company.",
      image: "8.png"
    }
  ];
  selectedTeam = 0;
  constructor() {}

  ngOnInit() {}
}
